import getErrorMessage from './getErrorMessage';
import getSuccessStatusCode from './getSuccessStatusCode';
import GroupFolderAction from './GroupFolderAction';

export default function parseGroupsRestResponse(
    action: GroupFolderAction,
    statusCode: number,
    responseText: string
) {
    try {
        const response = responseText?.length > 0 ? JSON.parse(responseText) : undefined;
        if (statusCode === getSuccessStatusCode(action)) {
            return {
                Success: true,
                Value: response,
            };
        } else {
            const errorMessage = getErrorMessage(action, statusCode, response);
            return {
                Success: false,
                ErrorMessage: errorMessage,
            };
        }
    } catch (error) {
        const errorMessage = error.message;
        return {
            Success: false,
            ErrorMessage: errorMessage,
        };
    }
}
